<template>
    <div class="table-responsive">
        <table class="table table-hover table-bordered">
            <thead>
            <tr class="text-center">
                <th scope="col">#</th>
                <th scope="col">Data</th>
                <th scope="col">Profissional</th>
                <th scope="col">Especialidade</th>
                <th scope="col">Forma de pagamento</th>
                <th scope="col">Status</th>
                <th scope="col">Celular</th>
                <th scope="col" v-if="showBtnEdit">Ações</th>
            </tr>
            </thead>
            <tbody :key="schedule.id_sched" v-for="schedule in schedules" class="text-center">
                <tr>
                    <td>
                        <button class="btn btn-sm btn-outline btn-outline-secondary"
                                type="button" data-bs-toggle="collapse"
                                :data-bs-target="'#subTable' + schedule.id_sched" aria-expanded="false"
                                aria-controls="collapseExample"
                                @click="onToggleCollapse(schedule.id_sched)">
                            <i class="bi bi-plus-circle"></i>
                        </button>
                    </td>
                    <td>
                        {{this.date(schedule.schedule_date_time).format('DD/MM/YYYY HH:mm')}}
                    </td>
                    <td>{{schedule.prof_name}}</td>
                    <td>
                        {{schedule.kind_name}} <br>
                        {{schedule.spec_name}}
                    </td>
                    <td>
                        {{schedule.paymeth_name}}
                        <span v-if="schedule.insurance_name != null">
                            <br>
                            {{schedule.insurance_name}}
                        </span>
                    </td>
                    <td>
                        <span class="badge" :style="{backgroundColor: schedule.sched_status_color}">
                            {{schedule.status_description}}
                        </span>
                    </td>
                    <td>{{maskIt(schedule.sched_patient_phone, '(##) #####-####')}}</td>
                    <td v-if="showBtnEdit">
                        <button class="btn btn-icon btn-outline btn-outline-default me-1" type="button"
                                title="Agendamentos"
                                @click="onClickBtnEditSchedule(schedule)">
                            <i class="bi bi-person-lines-fill"></i>
                        </button>
                    </td>
                </tr>
                <tr>
                    <td colspan="12" class="p-0">
                        <div :id="'subTable' + schedule.id_sched" class="collapse">
                            <hr>
                            <h4 class="text-center">Histórico de ações</h4>
                            <hr>
                            <table class="table table-bordered border-primary">
                                <thead>
                                <tr>
                                    <th>Data/Hora</th>
                                    <th>Usuário</th>
                                    <th>Ação</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="isLoadingLogs(schedule.id_sched)">
                                    <td colspan="3" class="text-center">
                                        <div class="spinner-border spinner-border-sm" role="status">
                                            <span class="visually-hidden">Carregando...</span>
                                        </div>
                                        <span class="ms-2">Carregando histórico...</span>
                                    </td>
                                </tr>
                                <tr v-else-if="hasScheduleLogs(schedule.id_sched)" v-for="log in getScheduleLogs(schedule.id_sched)" :key="log.id_schedule_log">
                                    <td>{{log.action_date}}</td>
                                    <td>{{log.user_name}}</td>
                                    <td>
                                        {{log.action_description}}
                                        <span v-if="log.metadata_description" class="text-muted">
                                            <br><small>{{log.metadata_description}}</small>
                                        </span>
                                    </td>
                                </tr>
                                <tr v-else-if="scheduleLogs[schedule.id_sched] !== undefined && !hasScheduleLogs(schedule.id_sched)">
                                    <td colspan="3" class="text-center text-muted">
                                        <em>Nenhum histórico disponível</em>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import http from "../../helpers/http";
import strMask from "../../helpers/strMask";

export default {
    name: "PatientScheduleTable",
    props: ['showBtnEdit', 'patientId', 'uniqueKey'],
    emits: ['onClickBtnEditSchedule'],
    data() {
        return {
            schedules: [],
            scheduleLogs: {}, // {scheduleId: [logs]}
            loadingLogs: {}, // {scheduleId: boolean}
        }
    },
    computed: {
        place() {
            return this.$store.state.auth.place;
        },
    },
    watch: {
      'uniqueKey': {
        handler() {
          this.getScheduleFromPatient();
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
        date: moment,
        maskIt(value, mask) {
            return strMask.it(value, mask);
        },
        getScheduleFromPatient() {
            if (!this.patientId)
                return;

            http.get(`/places/${this.place.id_place}/patients/${this.patientId}/schedules`).then((response) => {
                this.schedules = response.data;
            });
        },
        onToggleCollapse(scheduleId) {
            // Verificar se já tem logs carregados ou se está carregando
            if (this.scheduleLogs[scheduleId] !== undefined || this.loadingLogs[scheduleId]) {
                return;
            }

            // Iniciar carregamento
            this.loadingLogs[scheduleId] = true;
            this.scheduleLogs[scheduleId] = []; // Inicializar como array vazio

            http.get(`/places/${this.place.id_place}/schedules/${scheduleId}/logs`).then((response) => {
                this.scheduleLogs[scheduleId] = response.data || [];
            }).catch((error) => {
                console.error('Erro ao carregar logs do agendamento:', error);
                this.scheduleLogs[scheduleId] = [];
            }).finally(() => {
                this.loadingLogs[scheduleId] = false;
            });
        },
        getScheduleLogs(scheduleId) {
            return this.scheduleLogs[scheduleId] || [];
        },
        hasScheduleLogs(scheduleId) {
            return this.scheduleLogs[scheduleId] && this.scheduleLogs[scheduleId].length > 0;
        },
        isLoadingLogs(scheduleId) {
            return this.loadingLogs[scheduleId] === true;
        },
        onClickBtnEditSchedule(schedule) {
           this.$emit('onClickBtnEditSchedule', schedule);
        }
    }
}
</script>

<style scoped>

</style>